(function () {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function buildDiscountCode(qty, pct) {
    if (qty < 2 || !pct) return null;
    return 'BUNDLE' + qty + 'P' + pct;
  }

  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).catch(function () {});
  }

  function getProperty(item, key) {
    if (!item || !item.properties) return null;
    if (item.properties[key] != null) return item.properties[key];
    return null;
  }

  function computeBundleTotals(cart) {
    var original = 0;
    var discounted = 0;
    var hasBundle = false;

    (cart.items || []).forEach(function (item) {
      var discountedUnit = parseInt(getProperty(item, '_valor_discounted_unit'), 10) || 0;
      var lineOriginal = item.original_line_price || item.line_price || 0;
      var lineFinal = item.final_line_price != null ? item.final_line_price : lineOriginal;

      if (discountedUnit > 0) {
        hasBundle = true;
        original += lineOriginal;
        discounted += lineFinal;
      } else {
        original += lineOriginal;
        discounted += lineFinal;
      }
    });

    if (hasBundle && cart.total_discount > 0) {
      return {
        hasBundle: true,
        original: cart.items_subtotal_price,
        discounted: cart.total_price,
        savings: cart.total_discount
      };
    }

    return {
      hasBundle: hasBundle,
      original: original,
      discounted: discounted,
      savings: hasBundle ? Math.max(0, original - discounted) : 0
    };
  }

  function updateCartTotalsDisplay() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var totals = computeBundleTotals(cart);
        var displaySubtotal = totals.hasBundle ? totals.discounted : cart.total_price;
        var displayOriginal = totals.hasBundle ? totals.original : cart.items_subtotal_price;
        var displaySavings = totals.hasBundle ? totals.savings : cart.total_discount;

        document.querySelectorAll('[data-subtotal]').forEach(function (el) {
          el.textContent = formatMoney(displaySubtotal);
        });

        var hasSavings = displaySavings > 0;
        document.querySelectorAll('[data-valor-bundle-cart-original]').forEach(function (row) {
          row.hidden = !hasSavings;
          var priceEl = row.querySelector('[data-valor-bundle-cart-original-price]');
          if (priceEl) priceEl.textContent = formatMoney(displayOriginal);
        });

        document.querySelectorAll('[data-valor-bundle-cart-savings]').forEach(function (row) {
          row.hidden = !hasSavings;
          var amtEl = row.querySelector('[data-valor-bundle-cart-savings-amount]');
          if (amtEl) amtEl.textContent = '-' + formatMoney(displaySavings);
        });

        return cart;
      })
      .catch(function () {});
  }

  window.valorBundleCart = {
    buildDiscountCode: buildDiscountCode,
    applyDiscount: applyDiscount,
    computeBundleTotals: computeBundleTotals,
    updateCartTotalsDisplay: updateCartTotalsDisplay
  };

  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(updateCartTotalsDisplay, 500);
  });

  document.addEventListener('cart:build', function () {
    setTimeout(updateCartTotalsDisplay, 500);
  });

  if (document.body.classList.contains('template-cart')) {
    updateCartTotalsDisplay();
  }
})();
